import { useEffect, useState } from 'react';
import { useSetting } from './settings';
import { useUserPersonalInfo } from './user';

export default () => {
  const [riskAssessment, setRiskAssessment] = useState({
    userRisk: null,
    settings: null,
  });

  const [allowFeatureRiskAssessment] = useSetting(
    'server_configurations',
    'feature_enable_risk_assessment'
  );

  const { riskTier, nextTier, isLoading } = useUserPersonalInfo();

  useEffect(() => {
    if (allowFeatureRiskAssessment && riskTier && !isLoading) {
      setRiskAssessment({
        userRisk: riskTier,
        userNextTier: nextTier,
        settings: allowFeatureRiskAssessment,
      });
    }
  }, [allowFeatureRiskAssessment, riskTier, nextTier, isLoading]);

  return { riskAssessment, isLoading };
};
